export default __webpack_public_path__ + "static/media/navHomeLogo.83dd878f.svg";